import type { ReactNode } from 'react'
import { useErrorBoundary } from '@/shared/api'

interface FunctionalErrorBoundaryProps {
  children: ReactNode
}

export function FunctionalErrorBoundary({ children }: FunctionalErrorBoundaryProps) {
  const { error, resetError } = useErrorBoundary()

  if (error) {
    return (
      <div
        role="alert"
        style={{ padding: '1rem', backgroundColor: '#ffe6e6', color: '#a00' }}
      >
        <h2>Something went wrong.</h2>
        <p>{error.message}</p>
        <button onClick={resetError}>Try Again</button>
      </div>
    )
  }

  return children
}

export default FunctionalErrorBoundary
